const DIACRITICS_REGEX = new RegExp('[̀-ͯ]', 'g');

export function initials(name = '') {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function truncate(text = '', maxLength = 60) {
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength).trim()}…`;
}

export function slugify(text = '') {
  return text
    .normalize('NFD')
    .replace(DIACRITICS_REGEX, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}

export function normalizeSearchText(text = '') {
  return String(text ?? '')
    .normalize('NFD')
    .replace(DIACRITICS_REGEX, '')
    .toLowerCase();
}

export function highlightSegments(text = '', term = '') {
  const source = String(text ?? '');
  const needle = normalizeSearchText(term).trim();
  if (!needle) return [{ text: source, match: false }];
  const chars = Array.from(source);
  let normalized = '';
  const origin = [];
  chars.forEach((char, index) => {
    const piece = normalizeSearchText(char);
    normalized += piece;
    for (let i = 0; i < piece.length; i += 1) origin.push(index);
  });
  const start = normalized.indexOf(needle);
  if (start === -1) return [{ text: source, match: false }];
  const first = origin[start];
  const last = origin[start + needle.length - 1] + 1;
  return [
    { text: chars.slice(0, first).join(''), match: false },
    { text: chars.slice(first, last).join(''), match: true },
    { text: chars.slice(last).join(''), match: false }
  ].filter((segment) => segment.text);
}

export function currencyBRL(value = 0) {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
}
